import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import LoginForm from './Pages/LoginForm'
import MyBooks from './Pages/MyBooks'
import ToRead from './Pages/ToRead'
import Profile from './Pages/Profile'
import StatisticsDashboard from './Pages/StatisticsDashboard'
import SeriesManagement from './Pages/SeriesManagement'
import reportWebVitals from './reportWebVitals'
import { CookiesProvider } from 'react-cookie'
import { ApplicationProvider } from './Providers/ApplicationProvider'
import { ThemeModeProvider } from './Providers/ThemeModeProvider'
import ProtectedRoute from './Components/ProtectedRoute'
import AdminRoute from './Components/AdminRoute'
import AdminDashboard from './Pages/AdminDashboard'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { SnackbarProvider } from 'notistack'
import 'dayjs/locale/fr'
import { ROUTES } from './constants'

const root = ReactDOM.createRoot(document.getElementById('root'))

// Suppression globale des erreurs ResizeObserver non-exploitables
window.addEventListener('error', (event) => {
  const msg = event?.message || ''
  if (
    typeof msg === 'string' &&
    (msg.includes('ResizeObserver loop') ||
      msg.includes('ResizeObserver loop limit exceeded'))
  ) {
    event.stopImmediatePropagation()
    event.preventDefault()
  }
})

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason?.message || ''
  if (
    typeof reason === 'string' &&
    (reason.includes('ResizeObserver loop') ||
      reason.includes('ResizeObserver loop limit exceeded'))
  ) {
    event.preventDefault()
  }
})

root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
          <CssBaseline />
          <CookiesProvider defaultSetOptions={{ path: '/' }}>
            <ApplicationProvider>
            <BrowserRouter>
              <Routes>
                <Route
                  path={ROUTES.HOME}
                  element={<ProtectedRoute component={MyBooks} />}
                />
                <Route
                  path={ROUTES.TO_READ}
                  element={<ProtectedRoute component={ToRead} />}
                />
                <Route
                  path={ROUTES.PROFILE}
                  element={<ProtectedRoute component={Profile} />}
                />
                <Route
                  path={ROUTES.STATISTICS}
                  element={<ProtectedRoute component={StatisticsDashboard} />}
                />
                <Route
                  path={ROUTES.SERIES}
                  element={<ProtectedRoute component={SeriesManagement} />}
                />
                <Route
                  path="/admin/*"
                  element={<AdminRoute component={AdminDashboard} />}
                />
                <Route path={ROUTES.LOGIN} element={<LoginForm />} />
              </Routes>
            </BrowserRouter>
          </ApplicationProvider>
        </CookiesProvider>
      </LocalizationProvider>
      </SnackbarProvider>
    </ThemeModeProvider>
  </React.StrictMode>
)

reportWebVitals()
